import { render } from "./WorkflowDrawingIcon.vue?vue&type=template&id=74558baa"
const script = {}

import "./WorkflowDrawingIcon.vue?vue&type=style&index=0&id=74558baa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__